var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "px-1" },
    [
      _c("InputIcon", {
        staticClass: "mb-4 mt-2",
        attrs: { value: _vm.value.icon },
        on: {
          input: function ($event) {
            return _vm.updateValue($event, "icon")
          },
        },
      }),
      _vm._l(_vm.form, function (input) {
        return _c(
          "div",
          { key: input.label },
          [
            _c("InputTextField", {
              attrs: {
                value: _vm.value[input.key],
                label: input.label,
                suffix: input.suffix,
                type: input.type,
                "label-size": 12,
              },
              on: {
                input: function ($event) {
                  return _vm.updateValue($event, input.key)
                },
              },
            }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }